import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';

import { CompanyWebsiteAndBusinessInfoProps } from '../../../type';
import CompanyWebsiteBusinessInfo from './company-website-business-info';

const CompanyWebsiteBusinessInfoConatiner: React.FC<CompanyWebsiteAndBusinessInfoProps> = ({
  addChatMessage,
  saveCurrentStepDetails,
}) => {
  const stepRequestStatus = useSelector(
    (state: RootState) =>
      state.sequence?.saveAiSeqGeneratorStepDetailsRequest?.status,
  );

  return (
    <CompanyWebsiteBusinessInfo
      addChatMessage={addChatMessage}
      stepRequestStatus={stepRequestStatus}
      saveCurrentStepDetails={saveCurrentStepDetails}
    />
  );
};

export default memo(CompanyWebsiteBusinessInfoConatiner);
